import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";

export default function Categories() {
  const data = useStaticQuery(graphql`
    query {
      categoriesGroup: allMdx {
        group(field: frontmatter___category) {
          fieldValue
          totalCount
        }
      }
    }
  `);
  const sorted = (data.categoriesGroup.group || []).sort(
    ({ totalCount: a }, { totalCount: b }) => {
      if (a > b) return -1;
      if (b > a) return 1;

      return 0;
    }
  );
  //   console.log(data);
  return (
    <>
      <h3 className="bg-indigo-700 text-white text-center text-lg px-4 py-2 font-bold tracking-wider mb-2">
        Categories
      </h3>
      <ul className="flex flex-wrap">
        {(sorted || []).map(({ fieldValue: category, totalCount }, i) => (
          <li key={i} className="mr-1">
            <Link
              to={`/category/${category.toLowerCase()}`}
              className="text-indigo-800 bg-indigo-100 px-3 py-1 mb-1 inline-block rounded-full text-xs focus:outline-none focus:shadow-outline"
            >
              {category} ({totalCount})
            </Link>
          </li>
        ))}
      </ul>
    </>
  );
}
